/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TournamentType {
    GNK_SEASONAL = 'GNK / seasonal',
    ASYNCHRONOUS_TOURNAMENT = 'asynchronous tournament',
    CIRCUIT_BREAKER = 'circuit breaker',
    CIRCUIT_BREAKER_INVITATIONAL = 'circuit breaker invitational',
    CIRCUIT_OPENER = 'circuit opener',
    COMMUNITY_TOURNAMENT = 'community tournament',
    CONTINENTAL_CHAMPIONSHIP = 'continental championship',
    INFINITE_RECURSION = 'infinite recursion',
    INTERCONTINENTAL_CHAMPIONSHIP = 'intercontinental championship',
    NATIONAL_CHAMPIONSHIP = 'national championship',
    ONLINE_EVENT = 'online event',
    STORE_CHAMPIONSHIP = 'store championship',
    TEAM_TOURNAMENT = 'team tournament',
    WORLDS_CHAMPIONSHIP = 'worlds championship',
    REGIONAL_CHAMPIONSHIP = 'regional championship',
    PLAYERS_CIRCUIT = 'players circuit',
    CASUAL_TOURNAMENT_KIT = 'casual tournament kit',
    DISTRICT_CHAMPIONSHIP = 'district championship',
    MEGACITY_CHAMPIONSHIP = 'megacity championship',
}
